var _style, _path, _path2, _g, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFreetrial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 311.2 75",
    style: {
      enableBackground: "new 0 0 311.2 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#957833;}\n\t.st1{fill:#F4BC22;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1,11.8l16.7,43l-4-34.2V0.5L1,11.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.3,18.4l13.2,45.1l-11.7,10V33.9L269,18.4H297.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.9,11.8l1.5,51.6H10.5L2.9,38.7l7.6-26.8L296.9,11.8z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.8,11.8v51.6h45.4l-8.6-24.8l8.6-26.8L6.8,11.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.8,63.4V11.8H1v50.3v1.3H35.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.8,11.8l11.7,51.6h-49.8L278.2,38l-17.5-26.2H298.8z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreetrial);
export default __webpack_public_path__ + "static/media/Free trial.0d34b8e193720bf5ffb0fdf49c072e6a.svg";
export { ForwardRef as ReactComponent };